export type PartnershipBadgeType = 'premium' | 'exclusive' | null;

export type PartnershipPartner = {
  isPremium?: boolean;
  is_own_partnership?: boolean;
};

export const getPartnershipBadge = (partner?: PartnershipPartner | null): PartnershipBadgeType => {
  if (!partner) {
    return null;
  }

  if (partner.isPremium) {
    return 'premium';
  }

  if (partner.is_own_partnership) {
    return 'exclusive';
  }

  return null;
};

export const PARTNERSHIP_BADGE_ICONS: Record<Exclude<PartnershipBadgeType, null>, string> = {
  premium: 'assets/shared/img/partners/iconografia-fremium.svg',
  exclusive: 'assets/shared/img/icon-parcerias-exclusiva.svg',
};

export const PARTNERSHIP_BADGE_LABELS: Record<Exclude<PartnershipBadgeType, null>, string> = {
  premium: 'Parceiro premium',
  exclusive: 'Parceiro exclusivo',
};
